import { modalMenuPhoneStateSchema } from "../types/modalMenuPhoneTypes";

export const getModalMenuPhoneState = (state: modalMenuPhoneStateSchema) =>
  state.modalMenuPhone;
